'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { getAppleDeviceInfo } from '@shared/utils/helpers/get-apple-device-info';
import { useShouldShowInstallPrompt } from './use-should-show-install-prompt';
export const useAppleInstallPrompt = () => {
  const $ = _c(5);
  const [isApple, setIsApple] = useState(false);
  const [userShouldBePromptedToInstall, hideInstallPrompt] = useShouldShowInstallPrompt("iosInstallPromptedAt");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (!window.navigator.standalone) {
        setIsApple(getAppleDeviceInfo().isApple);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = isApple && userShouldBePromptedToInstall;
  let t3;
  if ($[2] !== hideInstallPrompt || $[3] !== t2) {
    t3 = [t2, hideInstallPrompt];
    $[2] = hideInstallPrompt;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};